export * from "../config";

export const OFFER_COMMON_TAB_TK = "OFFER_COMMON_TAB_TK";
export const OFFER_DASHBOARD_TAB_TK = "OFFER_DASHBOARD_TAB_TK";
export const OFFER_MANAGEMENT_TAB_TK = "OFFER_MANAGEMENT_TAB_TK";
export const OFFER_PERFORMANCE_TAB_TK = "OFFER_PERFORMANCE_TAB_TK";

export const OFFER_MANAGEMENT_DIALOG_TK = "OFFER_MANAGEMENT_DIALOG_TK";
export const OFFER_CANCEL_DIALOG_TK = "OFFER_CANCEL_DIALOG_TK";
export const OFFER_CANCEL_POS_DIALOG_TK = "OFFER_CANCEL_POS_DIALOG_TK";
export const OFFER_UPDATE_DIALOG_TK = "OFFER_UPDATE_DIALOG_TK";

export const OFFER_SLOT_TABLE_TK = "OFFER_SLOT_TABLE_TK";
export const OFFER_POS_TABLE_TK = "OFFER_POS_TABLE_TK";
